// extracted by mini-css-extract-plugin
module.exports = {"gallery":"Gallery_gallery__1r2FY","galleryImage":"Gallery_galleryImage__3d7Qh","btn":"Gallery_btn__V59PL","slider":"Gallery_slider__2BSGd"};